import bv115 from "./115";
import binhthanhhcm from "./binhthanhhcm";
import bthh from "./bthh";
import bvbnd from "./bvbnd";
import bvchoray_ttub from "./bvchoray_ttub";
import bvdktiengiang from "./bvdktiengiang";
import bvtndongnai from "./bvtndongnai";
import bvtwct from "./bvtwct";
import choray from "./choray";
import ctchhcm from "./ctchhcm";
import dalieuhcm from "./dalieuhcm";
import dkanphuoc from "./dkanphuoc";
import dkdongnai from "./dkdongnai";
import dkdongnai2 from "./dkdongnai2";
import dkkvangiang from "./dkkvangiang";
import dkvinhlong from "./dkvinhlong";
import leloi from "./leloi";
import medicsaigon from "./medicsaigon";
import medpro from "./medpro";
import medprodanang from "./medprodanang";
import minhanh from "./minhanh";
import momo from "./momo";
import nhidong1 from "./nhidong1";
import nhidonghcm from "./nhidonghcm";
import noitiettw from "./noitiettw";
import phuongchau from "./phuongchau";
import pkdkanhao from "./pkdkanhao";
import pkh from "./pkh";
import trungvuong from "./trungvuong";
import tvmbaclieu from "./tvmbaclieu";
import umc from "./umc";
import vanhanh from "./vanhanh";
import vientimhcm from "./vientimhcm";
import yduoccs2 from "./yduoccs2";

export default {
  phuongchau,
  minhanh,
  vientimhcm,
  bvdktiengiang,
  medpro,
  umc,
  trungvuong,
  leloi,
  dkkvangiang,
  nhidong1,
  yduoccs2,
  vanhanh,
  choray,
  bvchoray_ttub,
  "115": bv115,
  bthh,
  dkvinhlong,
  momo,
  dkdongnai,
  noitiettw,
  ctchhcm,
  tvmbaclieu,
  pkdkanhao,
  dkanphuoc,
  pkh,
  dalieuhcm,
  bvtwct,
  medicsaigon,
  binhthanhhcm,
  bvbnd,
  medprodanang,
  dkdongnai2,
  bvtndongnai,
  nhidonghcm
};
